
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import {Project, ProjectEvent} from "../../model/project";
import ProjectCardCarousel from "../project-card-carousel/project-card-carousel.vue";
import "./project.less";
import {dataService} from "@/services/data/category-data-service";

@Component({
  components: {
    ProjectCardCarousel
  }
})
export default class ProjectComponent extends Vue {
  @Prop() project!: Project | null;
  private subscription;


  private data ={
    category: dataService.category != null ? dataService.category: {id:0},
    country: dataService.country != null ? dataService.country: {id:0},
    paginator: dataService.paginator != null ? dataService.paginator: {id:0}
  };



  getLinkParameter(){
    let urlParameter = "?category="+this.data.category.id+"&country="+this.data.country.id;
    return urlParameter;
  }
  async mounted() {
    this.subscription = dataService.categoryData.data.subscribe(
            (ev) => {
              if(ev.event == 'update-attributes'){
                this.data = ev.data;
              }
            }
    );
    await this.$nextTick();

  }

  beforeDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  trans(key) {
    return translate(key);
  }

  navigate(url) {
    this.navigated(url+this.getLinkParameter());
    location.href = url+this.getLinkParameter();
  }

  getProjImages() {
    if (this.project!.images) {
      return [...this.project!.images!].sort(
        (im1, im2) => im2.is_cover - im1.is_cover
      );
    }
    return [];
  }

  @Emit("navigatedTo")
  private navigated(url) {}
}
